export class ClaimCertificateDto {
    retentionEpisodeId?: number;
    certificateUrl?: string;
}